<template>
  <no-ssr>
    <VueSlider
      ref="slider"
      v-bind="options"
      :value="propValue"
      @callback="emitInput($event)"
      @drag-end="$emit('drag-end')"
    />
  </no-ssr>
</template>

<script>
import noSSR from "vue-no-ssr";
import vars from "@/assets/scss/_variables.scss";

export default {
  name: "input-range",
  data() {
    return {
      defaultOptions: {
        bgStyle: {
          background: vars["gray-dark"],
          height: "4px",
        },
        sliderStyle: {
          background: vars["green-main"],
          border: "2px solid #fff",
          transform: "translateY(-1px)",
          boxShadow: "none",
        },
        processStyle: {
          background: vars["green-main"],
        },
        dotSize: 20,
        tooltip: false,
        enableCross: false,
        minRange: 0,
      },
    };
  },
  components: {
    "no-ssr": noSSR,
    VueSlider: vueOptions.ssr ? {} : require("vue-slider-component"),
  },
  props: {
    value: {
      type: [Number, Array],
      default: 0,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
  },
  computed: {
    propValue() {
      if (Array.isArray(this.value) && !this.value.length) {
        return [0, 100];
      }

      return [
        +this.value?.[0]?.toString().replace(/\D/g, ""),
        +this.value?.[1]?.toString().replace(/\D/g, ""),
      ];
    },
    options() {
      return {
        ...this.defaultOptions,
        min: this.min,
        max: this.max,
      };
    },
  },
  methods: {
    emitInput(value) {
      this.$emit("input", value);
      !this.$refs.slider.flag && this.$emit("drag-end", value);
    },
    refresh() {
      this.$refs.slider.refresh();
    },
  },
};
</script>

<style lang="scss"></style>
